import $ from 'jquery';

class EditableRateStar {
    constructor() {
        this.$container = $('<div class="editableRateStars rateStar"></div>');
        this.$stars = [];
        this.currentRating = 0;
        this.init();
    }

    onBeforeUpdate(){
        this.$container.trigger('onBeforeUpdate', [this.currentRating]);
    }

    onUpdate(){
        this.$container.trigger('onUpdate', [this.currentRating]);
    }

    getContainer(){
        return this.$container;
    }

    init(){
        for (let i = 0; i < 5; i++) {
            const $star = $('<i>').addClass('star icon-star-full');
            $star.on('mouseover', () => this.highlightStars(i));
            $star.on('mouseout', () => this.highlightStars(this.currentRating - 1));
            $star.on('click', () => this.setRating(i + 1));
            this.$stars.push($star);
            this.$container.append($star);
        }
        this.highlightStars(this.currentRating - 1);
    }

    highlightStars(index) {
        this.clearHighlight();
        for (let i = 0; i <= index; i++) {
            this.$stars[i].addClass('active');
        }
    }

    clearHighlight() {
        this.$stars.forEach($star => $star.removeClass('active'));
    }

    setRating(rating){
        this.onBeforeUpdate();
        this.currentRating = rating;
        this.highlightStars(rating - 1);

        this.onUpdate();
    }
}

export default EditableRateStar;
